var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 2,
    viewBox: "0 0 768 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 768,
    height: 1,
    fill: "black",
    fillOpacity: 0.24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 768,
    height: 1,
    fill: "white",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.5a24ccd8f114da92d2a942e76c783a98.svg";
export { ForwardRef as ReactComponent };